// Crypto logos mapping
export const cryptoLogos = {
  'USDT-ERC20': '/icons/crypto/usdt-erc20.png',
  'USDT-TRC20': '/icons/crypto/usdt-trc20.png',
  'USDT-BEP20': '/icons/crypto/usdt-bep20.png',
  'USDC-ERC20': '/icons/crypto/usdc-erc20.png',
};

export const cryptoNetworks = [
  { value: 'USDT-ERC20', label: 'USDT ERC20 (Ethereum)', logo: '/icons/crypto/usdt-erc20.png' },
  { value: 'USDT-TRC20', label: 'USDT TRC20 (Tron)', logo: '/icons/crypto/usdt-trc20.png' },
  { value: 'USDT-BEP20', label: 'USDT BEP20 (BSC)', logo: '/icons/crypto/usdt-bep20.png' },
  { value: 'USDC-ERC20', label: 'USDC ERC20 (Ethereum)', logo: '/icons/crypto/usdc-erc20.png' },
];

export const getCryptoLogo = (network, cryptoType) => {
  // Try to match by network-crypto combo
  const key = `${cryptoType || 'USDT'}-${network || 'ERC20'}`.toUpperCase();
  if (cryptoLogos[key]) return cryptoLogos[key];
  
  // Try network directly
  if (cryptoLogos[network]) return cryptoLogos[network];
  
  // Default
  return null;
};

export const getCryptoLogoByType = (type) => {
  return cryptoLogos[type] || null;
};
